<script>
  import DesktopNav from './DesktopNav/DesktopNav.svelte';
  import MobileNav from './MobileNav/MobileNav.svelte';
  import ImageSubnav from './ImageSubnav/ImageSubnav.svelte';
  import CtaSubnav from './CtaSubnav/CtaSubnav.svelte';
  import { initFlattenedNavRenderState, setAccessibilityRedesignRenderState } from '../../../js/stores';

  export let data = {};
  export let imageSubnavData = null;
  export let ctaSubnavData = null;
  export let desktopMode;
  export let mobileMode;

  const renderFlattenedNav = initFlattenedNavRenderState(data ? data.enableFlattenedNav : false);
  setAccessibilityRedesignRenderState(data ? data.enableAccessibilityRedesign && $renderFlattenedNav : false);
</script>

<header class="Header">
  <DesktopNav {data} {desktopMode} />
  <MobileNav {data} {mobileMode} />
  {#if imageSubnavData}
    <ImageSubnav navItems={imageSubnavData.navItems} />
  {/if}
  {#if ctaSubnavData}
    <CtaSubnav data={ctaSubnavData} />
  {/if}
</header>

<style>.Header :global(.hidden) {
  display: none !important;
}</style>
